import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  managementName: '',
};

const managementViewSlice = createSlice({
  name: 'managementView',
  initialState,
  reducers: {
    setManagementName(state, action) {
      state.managementName = action.payload;
    },
    resetManagementName(state) {
      state.managementName = '';
    },
  },
});

export const { setManagementName, resetManagementName } = managementViewSlice.actions;
export default managementViewSlice.reducer;
